import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card } from "../../../../shared/components/ui/Card";
import { Button } from "../../../../shared/components/ui/Button";
import { RadioGroup } from "../../../../shared/components/ui/RadioGroup";
import { ROUTES } from "../../../../routes/routes";

export const LifeguardDataAgreementPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [agreementStatus, setAgreementStatus] = useState<string>("");
  const [showError, setShowError] = useState<boolean>(false);

  const nextPath = location.state?.nextPath || ROUTES.LOGIN.LIFEGUARD;

  const handleContinue = () => {
    if (agreementStatus === "accepted") {
      navigate(nextPath, { replace: true });
    } else {
      setShowError(true);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAgreementStatus(e.target.value);
    if (e.target.value === "accepted") {
      setShowError(false);
    }
  };

  return (
    <div className="flex items-start justify-center pt-2 bg-gray-50 p-4">
      <div className="w-full max-w-md">
        <Card className="flex flex-col gap-4 shadow-md rounded-xl">
          <div className="flex flex-col gap-2">
            <h1 className="text-xl font-bold text-gray-900 text-center">
              Acuerdo de Tratamiento de Datos
            </h1>
          </div>

          <div className="bg-gray-50 p-3 rounded-lg text-xs sm:text-sm text-gray-700 leading-relaxed border border-gray-200">
            <p>
              "Yo como Personal de Salvamento encargado del diligenciamiento de
              este formulario, declaro bajo la gravedad del juramento que los
              datos aquí consignados fueron solicitados al propietario de los
              mismos para su acceso a la zona húmeda y piscinas; y que este, al
              brindarlos, acepta y reconoce que los datos entregados son reales
              y corresponden a datos de su propiedad; igualmente, que con el
              ingreso y uso de las instalaciones de la zona húmeda, acepta y
              autoriza el tratamiento de sus datos, se somete al reglamento de
              uso de las instalaciones y a ser llamado en su atención o
              retirado de la zona e instalaciones si incumpliere alguna de las
              disposiciones del reglamento o las indicaciones señaladas por mí
              como Personal de Salvamento encargado."
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <RadioGroup
              name="agreement"
              layout="horizontal"
              options={[
                { label: "Acepta", value: "accepted" },
                { label: "No Acepta", value: "rejected" },
              ]}
              value={agreementStatus}
              onChange={handleChange}
            />

            {showError || (agreementStatus === "rejected") ? (
              <div className="text-red-600 text-sm font-medium bg-red-50 p-3 rounded-md border border-red-100">
                Debes aceptar para continuar.
              </div>
            ) : null}
          </div>

          <div className="pt-2">
            <Button
              onClick={handleContinue}
              disabled={agreementStatus !== "accepted"}
              className="w-full"
            >
              Continuar
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};
